<template>
  <w-sliding-popup ref="slidingPopup" title="Top 5 성능자원 선택" width="600px"  @close="close">
    <div slot="content">
      <div class="title-h4 mr-b10">순서 설정</div>
      <draggable v-if="checkDataList.length > 0" v-model="checkDataList" class="list-drag-box mr-b25" element="ul" @start="isDraggable=true" @end="isDraggable=false">
         <li v-for="(item, index) in checkDataList" :key="`${item.managetypeId}-${item.rsctypeId}-${item.rscId}`" @mouseover="setMousePointer(index)" @mouseout="mousePoint = null">
           <div class="label">
             <span>{{`${item.managetypeName} > ${item.rsctypeName} > ${item.rscName}`}}</span>
           </div>
           <span class="c-pointer mr-r4"><i class="far fa-times" @click="remove(index)" v-show="index == mousePoint"></i></span>
         </li>
      </draggable>
      <el-row v-else class="mr-b15">
        <span>자원을 선택하세요.</span>
      </el-row>
      <div class="title-h4">자원 선택</div>
      <el-form :model="chartSetting" label-position="top">
        <el-row :gutter="20" class="mr-b10">
          <el-col :span="12">
            <el-form-item label="장비 종류" prop="objType">
              <el-select v-model="managetypeId" placeholder="Select" style="width:100%" @change="selectManageType">
                <el-option v-for="item in managetypeList" :key="item.managetypeId" :label="item.managetypeName" :value="item.managetypeId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="자원 구분" prop="sourceType">
              <el-select v-model="rsctypeId" placeholder="Select" style="width:100%" @change="selectRscType">
                <el-option-group
                v-for="group in rsctypeList"
                :key="group.key"
                :label="group.label">
                <el-option
                  v-for="item in group.data"
                  :key="item.rsctypeId"
                  :label="item.rsctypeName"
                  :value="item.rsctypeId">
                </el-option>
              </el-option-group>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table-wrapper :column-default="columnDefault" border :data="rscList" :columns="sourceColumns" :pagination="false"
        :show-custom-header="false" ref="mappingTable" header-align="center" highlight-current-row>
        <template slot="check-rsc-slot" slot-scope="scope">
          <el-checkbox @change="onCheckRsc" v-model="scope.row.check_flag" :disabled="(checkDataList.length > 4 && !scope.row.check_flag)"></el-checkbox>
        </template>
      </el-table-wrapper>
    </div>
    <el-row slot="footer">
        <el-button size="large" type="solid" @click="setChartSetting">저장</el-button>
        <el-button @click="close" size="large" >취소</el-button>
    </el-row>
  </w-sliding-popup>
</template>

<script>
import draggable from 'vuedraggable';
import { columnDefault } from '@/constants/table';
import perfApi from '@/api/performance/root';
import msgUtil from '@/utils/message';
import { isEmpty, differenceWith, isEqual, isNil, cloneDeep, filter } from 'lodash';
import { stringify } from 'querystring';

export default {
  name: 'WSummaryPerfChartSettingPopup',
  data() {
    return {
      mousePoint: null,
      columnDefault,
      rscList: [],
      sourceColumns: [
        {
          headerAlign: 'center',
          align: 'center',
          label: '선택',
          scopedSlot: 'check-rsc-slot',
          width: '70',
          prop: 'check_flag',
        },
        {
          prop: 'rscName',
          label: '자원',
        },
      ],
      chartSetting: {
        chartIndex: [],
      },
      checkDataList: [],
      originDataList: [],
      objType: null,
      sourceType: null,
      managetypeId: null,
      rsctypeId: null,
      deleteList: [],
      rsctypeList: [],
      widgetPosition: 1,
    };
  },
  components: {
    draggable,
  },
  computed: {
    managetypeList() {
      return filter(this.$store.getters.activeManagetypesToShowForRsc, (item) => item.managetypeId !== 'LMS');
    },
  },
  methods: {
    setMousePointer(index) {
      this.mousePoint = index;
    },
    /**
     * 사용자가 선택한 관리자원을 검사한다. 보유한 관리자원을 체크 설정하고
     * 사용자가 선택하는 자원의 수를 5개로 제한한다.
     * @author leesy918
     * @return {[type]} [description]
     */
    onCheckRsc() {
      if (this.checkDataList.length < 6) {
        this.rscList.forEach((item) => {
          if (!isNil(item.check_flag) && item.check_flag) {
            const checkIndex = this.checkDataList.findIndex((checkedItem) => checkedItem.rscId === item.rscId && checkedItem.rsctypeId === item.rsctypeId && checkedItem.managetypeId === item.managetypeId);
            if (checkIndex < 0) {
              item.widgetPosition = this.widgetPosition;
              item.managetypeName = this.managetypeList.find((managetype) => managetype.managetypeId === this.managetypeId).managetypeName;

              let rsctypeList = [];
              this.rsctypeList.forEach((group) => {
                rsctypeList = rsctypeList.concat(group.data);
              });
              item.rsctypeName = rsctypeList.find((rsctype) => rsctype.rsctypeId === this.rsctypeId).rsctypeName;

              this.checkDataList.push(item);
            }
          } else {
            const uncheckIndex = this.checkDataList.findIndex((checkedItem) => checkedItem.rscId === item.rscId && checkedItem.rsctypeId === item.rsctypeId && checkedItem.managetypeId === item.managetypeId);
            if (uncheckIndex > -1) {
              this.checkDataList.splice(uncheckIndex, 1);
            }
          }
        });
      }
    },
    /**
     * 설정한 관리자원을 제거한다.
     * @author leesy918
     * @param  {[type]} index [description]
     * @return {[type]}       [description]
     */
    remove(index) {
      const item = this.checkDataList[index];
      const checkItem = this.rscList.find((data) => item.rscId === data.rscId && item.rsctypeId === data.rsctypeId && item.managetypeId === data.managetypeId);
      if (!isNil(checkItem)) {
        checkItem.check_flag = false;
      }
      this.checkDataList.splice(index, 1);
    },
    selectManageType() {
      this.$nextTick(() => {
        this.loadRscTypeList();
      });
    },
    selectRscType() {
      this.$nextTick(() => {
        this.loadRscList();
      });
    },
    /**
     * 설정한 관리자원의 차트 데이터 조회
     * @author leesy918
     * @return {[type]} [description]
     */
    loadChartSetting() {
      const params = {
        widgetPosition: this.widgetPosition,
      };
      perfApi.getPerfChartSetting(params).then((response) => {
        if (response.data.success) {
          if (!isEmpty(response.data.data)) {
            this.checkDataList = response.data.data;
            this.originDataList = cloneDeep(response.data.data);
          }
        }
      });
    },
    /**
     * 관리대상 타입 조회
     * @author leesy918
     * @return {[type]} [description]
     */
    loadData() {
      this.managetypeId = this.managetypeList[0].managetypeId;
      this.loadRscTypeList();
    },
    /**
     * 관리 자원 타입 설정
     * @author leesy918
     * @return {[type]} [description]
     */
    loadRscTypeList() {
      const params = {
        managetypeId: this.managetypeId,
      };
      let managetypeKey = ['_'];
      let onlyPredictTarget = false;
      switch (this.managetypeId) {
        case 'NMS':
          managetypeKey = ['ND', 'NI'];
          break;
        case 'FMS':
          managetypeKey = ['FD', 'FS'];
          break;
        case 'VMS':
          managetypeKey = ['VCL', 'VHO', 'VVM', 'VDSC', 'VDS'];
          break;
        case 'DBMS':
          managetypeKey = ['_', 'TB', 'SY', 'PG', 'OR', 'MY', 'MS', 'IQ', 'IN', 'DB2', 'CU', 'AT'];
          break;
        default:
          managetypeKey = ['_'];
      }
      if (this.managetypeId === 'SMS' || this.managetypeId === 'NMS' || this.managetypeId === 'DBMS' || this.managetypeId === 'VMS' || this.managetypeId === 'SVC') {
        onlyPredictTarget = false;
      }
      params.managetypeKeyList = managetypeKey;
      params.onlyPredictTarget = onlyPredictTarget;
      perfApi.getSelectRsctypeList(params).then((response) => {
        if (response.data.success) {
          this.rsctypeList = response.data.data;
          this.rsctypeId = this.rsctypeList[0].data[0].rsctypeId;
          this.loadRscList();
        }
      });
    },
    /**
     * 선택한 관리대상의 관리자원 타입을 가진 관리 자원 조회
     * @author leesy918
     * @return {[type]} [description]
     */
    loadRscList() {
      this.$refs.mappingTable.$children[0].clearSelection();
      const params = {
        managetypeId: this.managetypeId,
        rsctypeId: this.rsctypeId,
      };
      this.rscList = [];
      perfApi.getSelectRscList(params).then((response) => {
        if (response.data.success) {
          const resultList = response.data.data;

          this.checkDataList.forEach((item) => {
            const checkItem = resultList.find((data) => (item.rscId === data.rscId) && (item.rsctypeId === data.rsctypeId) && (item.managetypeId === data.managetypeId));
            if (!isNil(checkItem)) {
              checkItem.check_flag = true;
            }
          });
          this.rscList = resultList;
        }
      });
    },
    /**
     * 사용자 TOP 5 설정 저장
     * @author leesy918
     */
    setChartSetting() {
      const queryString = stringify({ widgetPosition: this.widgetPosition });
      const deleteList = differenceWith(this.originDataList, this.checkDataList, isEqual);

      const param = {
        settingData: this.checkDataList,
        deleteList,
      };
      perfApi.setChartManagementData(param, queryString).then((response) => {
        if (response.data.success) {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.EDIT, '차트설정', true));
          this.$emit('settingChartData', this.widgetPosition);
          this.close();
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.EDIT, '차트설정', false));
        }
      });
    },
    open(widgetPosition) {
      this.widgetPosition = widgetPosition;
      this.checkDataList = [];
      this.$refs.slidingPopup.visible = true;
      this.$nextTick(() => {
        this.loadData();
        this.loadChartSetting();
      });
    },
    close() {
      this.mousePoint = null;
      this.widgetPosition = 1;
      this.$refs.slidingPopup.visible = false;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/performance/root/components/popup/SummaryPerfChartSettingPopup.vue